import React, { useEffect } from 'react';
import './App.css';
import './assets/styles/HomeImages.css';
import './assets/styles/ScrollEffects.css';
import { initScrollEffects } from './utils/scrollEffects';
import { BrowserRouter as Router } from 'react-router-dom';
import Footer from './components/layout/Footer';
import Navbar from './components/navigation/Navbar';
import AppRoutes from './routes/AppRoutes';



/**
 * 应用程序主组件
 * 实现类似截图中的现代简约风格
 * @returns {JSX.Element} 渲染的React组件
 */
const App: React.FC = () => {
  // 确保所有元素可见
  useEffect(() => {
    // 初始化一次，使所有元素可见
    initScrollEffects();
  }, []);



  /**
   * 渲染首页内容
   * @returns {JSX.Element} 首页内容
   */


  return (
    <Router>
      <div className="min-h-screen bg-background flex flex-col">
        {/* 导航栏 */}
        <Navbar />
        {/* 主要内容区域 */}
        <main className="flex-grow">
          <AppRoutes />
        </main>
        {/* 添加页脚 */}
        <Footer />
      </div>
    </Router>
  );
};

export default App;